'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var fieldLabel = require('./field-label-4ed9b7f8.js');
var component$3 = require('./component-eac14086.js');
var styles$s = require('./styles-66ea8e11.js');

var SelectButtonField = function (_a) {
    var options = _a.options, title = _a.title, name = _a.name, _b = _a.required, required = _b === void 0 ? false : _b, onChange = _a.onChange, variant = _a.variant, _c = _a.sizeOption, sizeOption = _c === void 0 ? 'sm' : _c, value = _a.value;
    return (React__default.createElement(styles$s.SelectButtonFieldContainer, null,
        React__default.createElement(fieldLabel.FieldLabel, { required: required, label: title }),
        React__default.createElement(styles$s.SelectButtonWrapper, null, options.map(function (button) { return (React__default.createElement(component$3.SelectButton, { key: button.value, name: name, text: button.label, value: button.value, sizeOption: sizeOption, checked: button.value === value, variant: variant, testId: name, onChange: onChange })); }))));
};

exports.SelectButtonField = SelectButtonField;
